import React from 'react';
import { Table } from 'react-bootstrap';

const SmartTable = ({
  data,
  columns,
  emptyState,
  onRowClick
}) => {
  return (
    <div className="smart-table">
      <div className="table-responsive">
        <Table striped bordered>
          <thead>
            <tr>
              {columns.map(({ key, keys, label }) => (
                <th
                  key={keys ? keys.join('-') : key}
                  style={{
                    minWidth: '120px',
                    backgroundColor: '#07002A',
                    color: 'white'
                  }}
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr
                key={item.id || index}
                onClick={() => onRowClick?.(item)}
                className={onRowClick ? 'clickable-row' : ''}
              >
                {columns.map(({ key, keys, render }) => (
                  <td key={keys ? keys.join('-') : key}>
                    {render ? (
                      render(item)
                    ) : keys ? (
                      <div className="multi-line-cell">
                        {keys.map(k => (
                          <div key={k} className="cell-line">
                            {item[k]}
                          </div>
                        ))}
                      </div>
                    ) : (
                      item[key]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {!data.length && (emptyState || (
        <div className="text-center py-5 text-muted">
          <p>No data available</p>
        </div>
      ))}
    </div>
  );
};

export default SmartTable;